import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { convertCurrency, formatNumber } from "../../../utils/helper";

const SourceDetailsCard = ({
  expensesUIChange,
  amt,
  title,
  incomeType,
  isIncome,
}) => {
  const selectedCurrency = useSelector(
    (state) => state.currency.currencySelected || "CAD"
  );
  const exchangeRates = useSelector((state) => state.currency.exchangeRates);
  const { t } = useTranslation();
  return (
    <>
      {!isIncome ? (
        <div className="col-12">
          <div className="sources-name-div">
            <h5 className="mb-0">{incomeType}</h5>
            <h5 className="mb-0">
              <small>{selectedCurrency}</small>{" "}
              {formatNumber(
                convertCurrency(amt || 0, exchangeRates, selectedCurrency)
              )}
            </h5>
          </div>
        </div>
      ) : (
        <div
          className={`row source-details-card ${
            expensesUIChange == "theme" ? "expenses-theme" : ""
          }`}
        >
          <div className="col-12">
            <h6 className="mb-0 d-flex align-items-center">
              {title} <span>{t("monthlyTag")}</span>
            </h6>
            <div className="sources-name-div">
              <h5 className="mb-0">{incomeType}</h5>
              <h5 className="mb-0">
                <small>{selectedCurrency}</small>{" "}
                {formatNumber(
                  convertCurrency(amt || 0, exchangeRates, selectedCurrency)
                )}
              </h5>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SourceDetailsCard;
